interface ConstructorParams {
  opcode: number;
  action: string;
  pid: string;
}

export class WebSocketMessage {
  opcode: number;
  action: string;
  pid: string;

  constructor({ opcode, action, pid }: ConstructorParams) {
    this.opcode = opcode;
    this.action = action;
    this.pid = pid;
  }

  toDict() {
    return {
      opcode: this.opcode.toString(),
      action: this.action,
      pid: this.pid,
    };
  }
}
